import * as React from 'react';

import { Button, Grid, List, ListItem, ListItemIcon, Spacer, Typography } from '@emburse/ui-core';
import { CheckIcon, Icon } from '@emburse/ui-essentials';

import { AMEX_PROFESSIONAL_SIX_DOLLARS_PER_USER_AMOUNT, AMEX_STARTER_FREE_PER_USER_AMOUNT } from '@Shared/constants';
import { ICompanyModel } from '@Shared/models';

import { ListItemWithCheckbox } from './SignUpSpendPlans';

import * as style from './SignUpPlanSelection.styl';

interface ISignUpAmexPlans {
  handleSelectPlan: (billing_plan: ICompanyModel['billing_plan']) => void;
  basicButtonText?: string;
  disableBasicButton?: boolean;
}

export const SignUpAmexPlans: React.FC<ISignUpAmexPlans> = ({
  handleSelectPlan,
  basicButtonText = 'Select',
  disableBasicButton = false
}) => {
  return (
    <Grid container direction={'row'} spacing={2} className={style.global}>
      <Grid item sm={6}>
        <div className="cardStyle">
          <Typography variant="h5">Starter</Typography>
          <Spacer size={24} />
          <Typography variant="h6" className="flex" style={{ alignItems: 'baseline' }}>
            {AMEX_STARTER_FREE_PER_USER_AMOUNT}
            <Typography variant="caption">/unlimited users</Typography>
          </Typography>
          <Spacer size={24} />
          <div className="flex jc-c">
            <Button
              style={{ width: '100%' }}
              onClick={() => handleSelectPlan('amex_starter_free_stripe')}
              data-testid="amex_starter_free_stripe"
              disabled={disableBasicButton}
              className="amex-starter"
            >
              {basicButtonText}
            </Button>
          </div>
          <Spacer size={24} />
          <List>
            <ListItem>
              <ListItemIcon>
                <Icon iconUrl={CheckIcon} />
              </ListItemIcon>
              American Express card feeds (Small business, Corporate and Purchasing)
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <Icon iconUrl={CheckIcon} />
              </ListItemIcon>
              Unlimited American Express virtual card issuing
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <Icon iconUrl={CheckIcon} />
              </ListItemIcon>
              Unlimited expense policies and approval
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <Icon iconUrl={CheckIcon} />
              </ListItemIcon>
              All accounting syncs and custom export (email automation supported)
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <Icon iconUrl={CheckIcon} />
              </ListItemIcon>
              Unlimited reimbursements (mileage tracking)
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <Icon iconUrl={CheckIcon} />
              </ListItemIcon>
              SSO and admin controlled 2FA
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <Icon iconUrl={CheckIcon} />
              </ListItemIcon>
              Mobile app (iOS and Android)
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <Icon iconUrl={CheckIcon} />
              </ListItemIcon>
              End user and admin support
            </ListItem>
          </List>
        </div>
      </Grid>
      <Grid item sm={6}>
        <div className="cardStyle">
          <Typography variant="h5">Plus</Typography>
          <Spacer size={24} />
          <Typography variant="h6" className="flex" style={{ alignItems: 'baseline' }}>
            {AMEX_PROFESSIONAL_SIX_DOLLARS_PER_USER_AMOUNT}
            <Typography variant="caption">/user per month&nbsp;</Typography>
            <Typography variant="caption">(Includes free 30 day trial)</Typography>
          </Typography>
          <Spacer size={24} />
          <div className="flex jc-c">
            <Button
              style={{ width: '100%' }}
              onClick={() => handleSelectPlan('amex_professional_six_dollars_stripe')}
              data-testid="amex_professional_six"
              className="amex-professional"
            >
              Select
            </Button>
          </div>
          <Spacer size={24} />
          <List>
            <ListItemWithCheckbox sx={{ fontWeight: 600 }}>Everything in Starter, +</ListItemWithCheckbox>
            <ListItemWithCheckbox>Salesforce API</ListItemWithCheckbox>
            <ListItemWithCheckbox>Amazon Business Integration</ListItemWithCheckbox>
            <ListItemWithCheckbox>
              <div>
                Multi-Subsidiary Support*<sup>, </sup>**
              </div>
            </ListItemWithCheckbox>
            <ListItemWithCheckbox>SFTP Accounting Automation*</ListItemWithCheckbox>
            <ListItemWithCheckbox>REST API Access*</ListItemWithCheckbox>
          </List>
          <Typography variant="caption">*Requires guided implementation</Typography>
          <Spacer size={8} />
          <Typography variant="caption">**Each subsidiary is billed separately based on usage</Typography>
        </div>
      </Grid>
    </Grid>
  );
};
